import { render } from "./ReviewFileWidget.vue?vue&type=template&id=3cd5e4e0&ts=true"
import script from "./ReviewFileWidget.ts?vue&type=script&lang=ts&external"
export * from "./ReviewFileWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__